import { render, staticRenderFns } from "./DeleteAccountPopup.vue?vue&type=template&id=0255ce27&scoped=true"
import script from "./DeleteAccountPopup.vue?vue&type=script&lang=ts"
export * from "./DeleteAccountPopup.vue?vue&type=script&lang=ts"
import style0 from "./DeleteAccountPopup.vue?vue&type=style&index=0&id=0255ce27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0255ce27",
  null
  
)

export default component.exports